(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (function () {
    /*
     * Filter / compare state model.
     *
     * filterOpen      — filter drawer visible.
     * compareMode     — compare overlay's peek (header) visible. The peek
     *                   is non-modal: opening it does NOT trap focus or
     *                   lock document scroll; the user can keep browsing.
     * compareExpanded — compare overlay's body (4-card grid) visible.
     *                   Implies compareMode. Modal-ish: traps focus + locks
     *                   scroll, and the backdrop appears.
     *
     * Mode/expanded toggles are mirrored onto `.compare-wrapper` as
     * `is-mode` / `is-expanded` classes, and to the Alpine `compareUi`
     * store so reactive bindings (chevron rotation, aria-expanded on the
     * morphing header button) stay in sync.
     */
    var filterOpen = false;
    var compareMode = false;
    var compareExpanded = false;
    var pendingFocusDrawer = null;

    var FOCUSABLE =
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function syncExpanded() {
      document.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', String(filterOpen));
      });
      /* The "Compare" entry button only exists in the --default row,
         which is inert (and thus not user-reachable) once compareMode
         flips on. Mirror state for ATs that walk the full DOM anyway. */
      document.querySelectorAll('[data-compare-mode-enter]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', String(compareMode));
      });
    }

    function getVisibleFocusable(container) {
      if (!container) return [];
      return Array.from(container.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetParent !== null;
      });
    }

    function setInert(el, shouldBeInert) {
      if (shouldBeInert) {
        el.setAttribute('inert', '');
      } else {
        el.removeAttribute('inert');
      }
    }

    /** Avoid document scroll when focusing controls inside fixed/sticky drawers */
    function focusWithoutScroll(el) {
      if (!el || typeof el.focus !== 'function') return;
      try {
        el.focus({ preventScroll: true });
      } catch (err) {
        el.focus();
      }
    }

    function updateScrollLock() {
      /* Peek mode alone shouldn't lock scroll — the user is still
         browsing the collection. Only lock when the filter drawer is
         open OR the compare overlay's body is fully expanded.

         Ref-counted (see src/scroll-lock.js) because the header's menus
         lock the same page: closing this drawer while one of those is
         open must not unlock the page underneath it. */
      if (filterOpen || compareExpanded) {
        window.themeScrollLock?.lock('facets');
      } else {
        window.themeScrollLock?.unlock('facets');
      }
    }

    function ensureToggleAtBottom() {
      var toggle = document.getElementById('facets-toggle');
      if (!toggle) return;
      var rect = toggle.getBoundingClientRect();
      /* Account for the sticky `bottom` offset — on desktop the bar
         deliberately floats 16px above the viewport bottom (see
         `.facets-toggle` @media >=768px), so a 16px gap is the bar's
         intended resting position, NOT a sign that the bar is detached
         from the bottom. Without this subtraction the function would
         fire on every desktop open and scroll the page up by 16px,
         which reads as a "jump" when the drawer appears. */
      var stickyOffset = parseFloat(getComputedStyle(toggle).bottom) || 0;
      var gap = window.innerHeight - rect.bottom - stickyOffset;
      if (gap > 10) {
        window.scrollBy(0, -gap);
      }
    }

    /*
     * Morph the bottom CTA bar.
     *
     * `.facets-toggle__actions` holds three sibling rows: --default,
     * --filter-open, --compare-mode. We pick exactly one to be active,
     * and `inert` the others so they fade out *and* drop out of the
     * keyboard / SR focus order. The CSS handles the crossfade timing
     * keyed off the `inert` attribute.
     *
     * Precedence: filter > compare-mode > default. Filter wins because
     * opening it gives a full-screen-ish drawer that needs its own
     * "Clear all / See N items" CTAs.
     */
    function syncToggleBarRows() {
      var defaultRow = document.querySelector('.facets-toggle__actions__row--default');
      var filterRow = document.querySelector('.facets-toggle__actions__row--filter-open');
      var compareModeRow = document.querySelector('.facets-toggle__actions__row--compare-mode');
      var activeRow = filterOpen ? 'filter' : compareMode ? 'compare-mode' : 'default';
      if (defaultRow) setInert(defaultRow, activeRow !== 'default');
      if (filterRow) setInert(filterRow, activeRow !== 'filter');
      if (compareModeRow) setInert(compareModeRow, activeRow !== 'compare-mode');
    }

    function syncCompareUiStore() {
      if (typeof window.Alpine === 'undefined' || !window.Alpine.store) return;
      try {
        var ui = window.Alpine.store('compareUi');
        if (!ui) return;
        ui.mode = compareMode;
        ui.expanded = compareExpanded;
      } catch (err) {
        /* Alpine not ready */
      }
    }

    function applyFilter() {
      if (filterOpen) ensureToggleAtBottom();

      var wrapper = document.querySelector('[data-filter-wrapper]');
      var overlay = document.querySelector('[data-filter-overlay]');
      if (wrapper) {
        wrapper.classList.toggle('is-open', filterOpen);
        setInert(wrapper, !filterOpen);
      }
      var toggleBar = document.getElementById('facets-toggle');
      if (toggleBar) {
        if (filterOpen) {
          toggleBar.setAttribute('role', 'dialog');
          toggleBar.setAttribute('aria-modal', 'true');
          toggleBar.setAttribute('aria-labelledby', 'filters-drawer-heading');
        } else {
          toggleBar.removeAttribute('role');
          toggleBar.removeAttribute('aria-modal');
          toggleBar.removeAttribute('aria-labelledby');
        }
      }
      if (overlay) overlay.classList.toggle('is-open', filterOpen);
      syncExpanded();
      syncToggleBarRows();
      updateScrollLock();

      if (filterOpen && wrapper && pendingFocusDrawer === 'filter') {
        pendingFocusDrawer = null;
        var close = wrapper.querySelector('.facets-drawer__close');
        focusWithoutScroll(close);
      }
    }

    function applyCompare() {
      if (compareMode || compareExpanded) ensureToggleAtBottom();

      var wrapper = document.querySelector('[data-compare-wrapper]');
      var overlay = document.querySelector('[data-compare-overlay]');
      if (wrapper) {
        wrapper.classList.toggle('is-mode', compareMode);
        wrapper.classList.toggle('is-expanded', compareExpanded);
        /* Inert the wrapper entirely when compareMode is off. When the
           peek is showing but the body is collapsed, the header (one
           label + one action button) stays interactive — that's the
           whole point of the peek. */
        setInert(wrapper, !compareMode);
      }
      /* Backdrop only appears with the body, not with the peek alone.
         The peek is part of normal page flow, no scrim needed. */
      if (overlay) overlay.classList.toggle('is-open', compareExpanded);
      syncExpanded();
      syncToggleBarRows();
      updateScrollLock();
      syncCompareUiStore();

      if (compareExpanded && wrapper && pendingFocusDrawer === 'compare') {
        pendingFocusDrawer = null;
        /* Focus the header action button (chevron in this state) so
           Esc/Enter immediately collapse the body again. */
        var action = wrapper.querySelector('.compare-header__action');
        focusWithoutScroll(action);
      }
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-filter-toggle]')) {
        /* Opening the filter while compare is expanded should collapse
           the compare body (it would otherwise sit underneath the
           filter panel). Peek state stays so the user gets the same
           compare-mode bar back when they close the filter. */
        if (compareExpanded) {
          compareExpanded = false;
          applyCompare();
        }
        filterOpen = !filterOpen;
        if (filterOpen) pendingFocusDrawer = 'filter';
        applyFilter();
      } else if (e.target.closest('[data-filter-overlay]')) {
        filterOpen = false;
        applyFilter();
      } else if (e.target.closest('[data-compare-mode-enter]')) {
        if (filterOpen) {
          filterOpen = false;
          applyFilter();
        }
        compareMode = true;
        compareExpanded = false;
        applyCompare();
        var peekAction = document.querySelector('.compare-header__action');
        focusWithoutScroll(peekAction);
      } else if (e.target.closest('[data-compare-mode-exit]')) {
        compareMode = false;
        compareExpanded = false;
        applyCompare();
        var enterBtn = document.querySelector('[data-compare-mode-enter]');
        focusWithoutScroll(enterBtn);
      } else if (e.target.closest('[data-compare-expand-toggle]')) {
        /* Gate on selection count — the chevron only renders at >=2
           items, but guard here too for keyboard activation timing. */
        var len = 0;
        if (window.Alpine && window.Alpine.store) {
          try {
            len = window.Alpine.store('compare').items.length;
          } catch (err) {
            /* noop */
          }
        }
        if (len < 2) return;
        if (filterOpen) {
          filterOpen = false;
          applyFilter();
        }
        compareExpanded = !compareExpanded;
        if (compareExpanded) pendingFocusDrawer = 'compare';
        applyCompare();
      } else if (e.target.closest('[data-compare-overlay]')) {
        /* Backdrop click collapses the body but keeps the peek so the
           user can re-expand or pick more items. */
        compareExpanded = false;
        applyCompare();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (filterOpen) {
          filterOpen = false;
          applyFilter();
          var filterBtn = document.querySelector('.facets-toggle__button[data-filter-toggle]');
          focusWithoutScroll(filterBtn);
        } else if (compareExpanded) {
          /* Esc collapses one layer at a time: expanded → peek, then
             a second Esc exits peek mode entirely. */
          compareExpanded = false;
          applyCompare();
          var actionBtn = document.querySelector('[data-compare-expand-toggle]');
          focusWithoutScroll(actionBtn);
        } else if (compareMode) {
          compareMode = false;
          applyCompare();
          var enterBtn2 = document.querySelector('[data-compare-mode-enter]');
          focusWithoutScroll(enterBtn2);
        }
      }

      /* Focus trap is only active for fully-modal layers: filter drawer
         and compare body. Peek alone doesn't trap focus. */
      if (e.key === 'Tab') {
        var activeDrawer = filterOpen
          ? document.querySelector('[data-filter-wrapper]')
          : compareExpanded
            ? document.querySelector('[data-compare-wrapper]')
            : null;
        if (!activeDrawer) return;

        const ctaRow = filterOpen
          ? document.querySelector('.facets-toggle__actions__row--filter-open')
          : compareExpanded
            ? document.querySelector('.facets-toggle__actions__row--compare-mode')
            : null;
        const regions = ctaRow ? [activeDrawer, ctaRow] : [activeDrawer];

        const focusable = regions.reduce(function (acc, region) {
          return acc.concat(getVisibleFocusable(region));
        }, []);
        if (focusable.length === 0) return;

        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        const inside = regions.some(function (region) {
          return region.contains(document.activeElement);
        });

        if (e.shiftKey) {
          if (document.activeElement === first || !inside) {
            e.preventDefault();
            focusWithoutScroll(last);
          }
        } else {
          if (document.activeElement === last || !inside) {
            e.preventDefault();
            focusWithoutScroll(first);
          }
        }
      }

      if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('.toggle__input[role="switch"]')) {
        e.preventDefault();
        e.target.checked = !e.target.checked;
        e.target.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    /*
     * Reactive sync from the compare store back into the IIFE.
     *
     * The Alpine store auto-surfaces the peek when items are added (via
     * `_surfacePeek` in app.js); we mirror that into `compareMode` here
     * so the morphing bar / inert state / DOM classes follow. We also
     * force-collapse the body when the selection drops below 2 — the
     * chevron disappears at that point, and an open body with no way
     * to close it from the header would be a dead end.
     */
    function watchCompareStore() {
      if (typeof window.Alpine === 'undefined' || !window.Alpine.effect) {
        setTimeout(watchCompareStore, 50);
        return;
      }
      window.Alpine.effect(function () {
        var compare = window.Alpine.store('compare');
        var ui = window.Alpine.store('compareUi');
        if (!compare || !ui) return;
        var len = compare.items.length;

        if (ui.mode && !compareMode) {
          compareMode = true;
          applyCompare();
        }
        if (len < 2 && compareExpanded) {
          compareExpanded = false;
          applyCompare();
        }
      });
    }
    watchCompareStore();

    var observer = new MutationObserver(function () {
      if (filterOpen) applyFilter();
      if (compareMode || compareExpanded) applyCompare();
    });

    var observeTarget = document.getElementById('ResultsList') || document.body;
    observer.observe(observeTarget, { childList: true, subtree: true });

    /*
     * Scroll an opened filter accordion into view above the CTA bar.
     *
     * Native `<details>` doesn't auto-scroll on open, so when a user taps
     * a filter near the bottom of the drawer the expanded options render
     * underneath the morphing CTA bar (which overlays the panel's bottom).
     *
     * `toggle` does not bubble, so we attach in the capture phase to catch
     * it on any descendant `<details>` inside the filter drawer. We
     * `requestAnimationFrame` once so the browser has applied the
     * `[open]` state's layout (otherwise `getBoundingClientRect()` still
     * reflects the collapsed height and we'd under-scroll).
     */
    document.addEventListener(
      'toggle',
      function (e) {
        var details = e.target;
        if (!details || !details.matches || !details.matches('details.facets__panel')) return;
        if (!details.open) return;
        var container = details.closest('.facets-drawer__filters');
        if (!container) return;

        requestAnimationFrame(function () {
          var detailsRect = details.getBoundingClientRect();
          var containerRect = container.getBoundingClientRect();
          /* Effective bottom of usable scroll viewport: container bottom
             minus the area the bar overlays. Mirrors the
             `padding-block-end` reservation on `.facets-drawer__filters`. */
          var barOverlap = 56 /* bar height */ + 16 /* footer strip */ + 16; /* breathing */
          var effectiveBottom = containerRect.bottom - barOverlap;
          var overflow = detailsRect.bottom - effectiveBottom;
          if (overflow > 0) {
            container.scrollBy({
              top: overflow,
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            });
          }
        });
      },
      true,
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
